'use client'

import Link from 'next/link'
import type { ComponentProps } from 'react'

import { track, type TrackOptions } from '@/lib/analytics/track'

type TrackedCtaLinkProps = ComponentProps<typeof Link> & {
  /** PostHog/GA event name fired on click. */
  event: string
  /** Properties sent with the event. */
  eventProperties?: Record<string, unknown>
  /** Optional Meta Pixel standard-event mapping (e.g. 'Lead'). */
  trackOptions?: TrackOptions
}

/**
 * A `next/link` that fires an analytics event on click. Lets server components
 * keep a conversion CTA tracked without becoming client components themselves.
 */
export function TrackedCtaLink({
  event,
  eventProperties,
  trackOptions,
  onClick,
  children,
  ...linkProps
}: TrackedCtaLinkProps) {
  return (
    <Link
      {...linkProps}
      onClick={e => {
        track(event, eventProperties, trackOptions)
        onClick?.(e)
      }}
    >
      {children}
    </Link>
  )
}
